// ATIVAÇÃO CONTROLADA DA TRAVA DE MARGEM, por unidade pagadora.
//
// Esta é a única tela do produto que pode parar averbação legítima. Ligar a
// trava faz um vínculo com pendência receber `margem_pendente_classificacao` em
// vez de uma margem — o banco não consegue averbar para aquele servidor, em
// nenhum dos seis caminhos de escrita.
//
// A tela é um ORQUESTRADOR, e a divisão em três módulos não é por tamanho: as
// seções têm CICLOS DE VIDA DE DADOS DIFERENTES, e misturá-las foi o que produziu
// o acoplamento da versão anterior, em que trocar de unidade mexia no que o
// operador estava lendo no monitor.
//
//   decisão   medição sem cache, válida por 10 minutos, disparada só por ação
//   fila      invalida quando alguém classifica uma verba
//   monitor   atualiza sozinho a cada 30s, e o recorte do operador sobrevive
//
// O que NÃO existe aqui, e é deliberado (ADR-0005): ação em lote, herança entre
// matriz e filial, e qualquer pré-condição de sistema para desligar.

import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { QUERY_UNIDADES_OPERAVEIS, listarUnidadesOperaveis } from "../../lib/unidades-operaveis";
import { TravaMargemDecisao } from "./trava-margem-medicao";
import { TravaMargemFila } from "./trava-margem-fila";
import { TravaMargemMonitor } from "./trava-margem-monitor";
import type { Unidade } from "./trava-margem-unidades";

export function AverbadoraTravaMargem() {
  const [unidadeId, setUnidadeId] = useState<number | null>(null);

  // Uma consulta só responde "quais unidades existem, como se agrupam, e quais
  // estão ligadas" — o panorama que a tela precisa ANTES de medir qualquer
  // coisa. O `travaAtiva` entrou nesta rota exatamente para isso.
  const prefeituras = useQuery({
    queryKey: QUERY_UNIDADES_OPERAVEIS,
    queryFn: listarUnidadesOperaveis,
  });
  const unidades = (prefeituras.data?.prefeituras ?? []) as unknown as Unidade[];
  const unidadeNome = unidades.find((u) => u.id === unidadeId)?.nome;

  return (
    <div style={{ display: "grid", gap: 24, maxWidth: 1100 }}>
      <header>
        <h1 style={{ margin: 0 }}>Trava de margem por unidade</h1>
        <p style={{ color: "var(--text-muted)", marginTop: 4, maxWidth: 760 }}>
          Com a trava <strong>ligada</strong>, um vínculo com desconto sem produto classificado deixa de
          receber margem e a consignatária não consegue averbar para ele. Com a trava <strong>desligada</strong>, a
          pendência continua sendo medida, mas nada é bloqueado. Contratos já averbados não são afetados em
          nenhum dos dois casos.
        </p>
      </header>

      <TravaMargemDecisao unidadeId={unidadeId} onUnidade={setUnidadeId} />
      <TravaMargemFila unidadeId={unidadeId} unidadeNome={unidadeNome} />
      <TravaMargemMonitor unidades={unidades} />
    </div>
  );
}
